<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="reservedInstanceList"
      style="width: 100.1%;"
      :loading="modalLoading"
      :max-height="tableHeight"
    >
      <template slot-scope="{ row, index }" slot="operation">
        <Button
          type="info"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:reservedInstanceResource:redshift:config'
          ]"
          size="small"
          @click="configTag(row)"
          >{{ $t('RAM.AWS.reservedInstanceTag.configTag') }}</Button
        >
      </template>
    </Table>
    <!-- 配置标签页面 -->
    <configuration-reserved-instance-tag
      v-if="isShowReservedInstanceTag"
      ref="configurationReservedInstanceTag"
    ></configuration-reserved-instance-tag>
  </div>
</template>
<script>
import utils from "../../../../../../utils/utils.js";
import ConfigurationReservedInstanceTag from "../ConfigurationReservedInstanceTag";

var tableRedShiftResourceVue = {};
export default {
  name: "TableRedShiftResource",
  components: {
    ConfigurationReservedInstanceTag
  },
  data() {
    return {
      tableHeight: 0,
      isShowReservedInstanceTag: false,
      modalLoading: false,
      columns: [
        {
          title: this.$t("RAM.AWS.RI.RedShift.accountID"),
          fixed: "left",
          minWidth: 120,
          key: "awsId"
        },
        {
          title: this.$t("RAM.AWS.RI.RedShift.accountName"),
          key: "awsName",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.RedShift.region"),
          key: "region",
          minWidth: 150
        },
        {
          title: "tag",
          key: "tag",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.RedShift.reservedNodeID"),
          key: "id",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.RedShift.NodeType"),
          key: "instanceType",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.RedShift.productType"),
          key: "offeringType",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.RedShift.start"),
          key: "start",
          minWidth: 150,
          sortable: true
        },
        {
          title: this.$t("RAM.AWS.RI.RedShift.overdue"),
          key: "end",
          minWidth: 150,
          sortable: true
        },
        {
          title: this.$t("RAM.AWS.RI.RedShift.due"),
          key: "duration",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.RedShift.status"),
          key: "state",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.RedShift.amount"),
          key: "instanceCount",
          minWidth: 150
        },
        {
          title: this.$t("common.operation"),
          minWidth: 150,
          fixed: "right",
          slot: "operation"
        }
      ],
      reservedInstanceList: [],
      reservedInstanceListData: []
    };
  },
  beforeCreate: function() {
    tableRedShiftResourceVue = this;
  },
  mounted() {
    window.addEventListener("resize", this.getTableHeight);
    this.getTableHeight();
  },
  methods: {
    getTableHeight() {
      this.tableHeight = window.innerHeight - 210;
    },
    // 显示数据
    getReservedInstances: function(reservedInstanceDTO) {
      tableRedShiftResourceVue.reservedInstanceDTO = reservedInstanceDTO;
      // 转圈圈
      tableRedShiftResourceVue.modalLoading = true;
      // 清空数据
      tableRedShiftResourceVue.reservedInstanceList = [];
      tableRedShiftResourceVue.$api.reservedInstance
        .getReservedNodes(reservedInstanceDTO)
        .then(res => {
          tableRedShiftResourceVue.modalLoading = false;
          if (res == null || res.data == null) {
            return;
          }
          let reservedInstances = res.data;
          for (let i = 0; i < reservedInstances.length; i++) {
            reservedInstances[i].start = utils.methods.formatDate(
              reservedInstances[i].start
            );
            reservedInstances[i].end = utils.methods.formatDate(
              reservedInstances[i].end
            );
            reservedInstances[i].duration =
              reservedInstances[i].duration === 31536000
                ? tableRedShiftResourceVue.$t(
                    "RAM.AWS.reservedInstanceTag.oneYear"
                  )
                : tableRedShiftResourceVue.$t(
                    "RAM.AWS.reservedInstanceTag.threeYears"
                  );
          }
          tableRedShiftResourceVue.reservedInstanceListData = JSON.parse(
            JSON.stringify(reservedInstances)
          );
          tableRedShiftResourceVue.reservedInstanceList = reservedInstances;
        });
    },
    configTag: function(row) {
      this.isShowReservedInstanceTag = true;
      this.$nextTick(function() {
        this.$refs.configurationReservedInstanceTag.getConfigurationReservedInstanceTagList(
          row,
          3
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/redshift/TableRedshiftResource.vue